import { SearchInput } from '../../../components/form/shared/search-input'
import { CargoFilter } from './cargo-filter'

interface UserFiltersProps {
  searchTerm: string
  setSearchTerm: (value: string) => void
  selectedCargo: string
  setSelectedCargo: (value: string) => void
}

export function UserFilters({ searchTerm, setSearchTerm, selectedCargo, setSelectedCargo }: UserFiltersProps) {
  return (
    <div className="flex flex-1 flex-col gap-4 md:flex-row">
      <SearchInput value={searchTerm} onChange={setSearchTerm} />
      <CargoFilter value={selectedCargo} onChange={setSelectedCargo} />
    </div>
  )
}
